import { UXPage } from '../../../core/models/ux-page';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';
var PageDecorationComponent = /** @class */ (function () {
    function PageDecorationComponent(store) {
        this.store = store;
        this.type = 'default';
        this.fullWidthView$ = store
            .pipe(select(fromBase.isFullWidthViewEnabled));
    }
    Object.defineProperty(PageDecorationComponent.prototype, "hasBanner", {
        get: function () {
            return !!this.page.banner && !!this.page.banner.img;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageDecorationComponent.prototype, "banner", {
        get: function () {
            return this.page.banner;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageDecorationComponent.prototype, "hasBlocks", {
        get: function () {
            return !!this.page.blocks.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageDecorationComponent.prototype, "hasPageText", {
        get: function () {
            return !!this.page.introText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageDecorationComponent.prototype, "blocks", {
        get: function () {
            return this.page.blocks;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageDecorationComponent.prototype, "hasText", {
        get: function () {
            return !!this.page.introText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageDecorationComponent.prototype, "text", {
        get: function () {
            return this.page.introText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageDecorationComponent.prototype, "name", {
        get: function () {
            return this.page.name;
        },
        enumerable: true,
        configurable: true
    });
    return PageDecorationComponent;
}());
export { PageDecorationComponent };
